import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { FacilityReportDetails } from "../../components/FacilityReportsComponents/FacilityReportDetails";
import { FacilityReportsBackLink } from "../../components/FacilityReportsComponents/FacilityReportsBackLink";
import { FacilityReportsList } from "../../components/FacilityReportsComponents/FacilityReportsList";
import { useFacilityReports } from "../../components/FacilityReportsComponents/FacilityReportsList/hooks";
import { ModalCreateNewFacilityReport } from "../../components/FacilityReportsComponents/FacilityReportsList/ModalCreateNew";

import "./styles.scss";

interface MatchParams {
  facilityReportId?: string;
}

type IFacilityReportsPageProps = RouteComponentProps<MatchParams>;

const FacilityReportsPage: React.FunctionComponent<
  IFacilityReportsPageProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityReportsPage.${key}`);

  const { facilityReportId } = props.match.params;

  const [isModalCreateNewOpen, setIsModalCreateNewOpen] = useState(false);

  const { create } = useFacilityReports();

  const handleCreateReport = async (payload: any) => {
    try {
      await create(payload);
      handleCloseModalCreateNew();
    } catch {
      // Do nothing. Axios should handle displaying the error automatically.
    }
  };

  const handleOpenModalCreateNew = () => {
    setIsModalCreateNewOpen(true);
  };

  const handleCloseModalCreateNew = () => {
    setIsModalCreateNewOpen(false);
  };

  return (
    <>
      <div className="right-content facility-reports-page">
        <div className="top-title-bar">
          <div className="top-title-bar-left">
            {facilityReportId && (
              <FacilityReportsBackLink facilityReportId={facilityReportId} />
            )}
            <PageTitle text={t("facility_reports")} />
          </div>
          <button className="btn btn-blue" onClick={handleOpenModalCreateNew}>
            {t("create_report")}
          </button>
        </div>
        {facilityReportId && (
          <FacilityReportDetails facilityReportId={facilityReportId} />
        )}

        {!facilityReportId && <FacilityReportsList />}
      </div>
      {isModalCreateNewOpen && (
        <ModalCreateNewFacilityReport
          handleClose={handleCloseModalCreateNew}
          handleSubmit={handleCreateReport}
        />
      )}
    </>
  );
};

export default withRouter(FacilityReportsPage);
